import type { Translation } from "@/i18n/locales/types";

export const shared: Translation["shared"] = {
  DataTable: {
    collapse_row: "Collapse row",
    error_description: "Please try refreshing the page or contact support.",
    error_title: "Something went wrong",
    expand_row: "Expand row",
    page_literal: "Page {{pageFrom}} of {{pageTo}}",
    select_all: "Select all",
    select_row: "Select",
  },
  Filters: {
    apply: "Apply",
    date_ranges: {
      currentMonth: "This month",
      currentWeek: "This week",
      pastMonth: "Last month",
      pastWeek: "Last week",
      title: "Date ranges",
    },
  },
  FormManager: {
    actions: {
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      save: "Save",
    },
    delete: {
      confirm: "Are you sure you want to delete {{what}}?",
      description: "This action cannot be undone.",
    },
    labels: {
      boolean: {
        false: "No",
        true: "Yes",
      },
    },
    messages: {
      deleted: "Deleted",
      deleting: "Deleting",
      error_deleting: "Could not delete",
      error_saving: "Could not save",
      saved: "Saved",
      saving: "Saving",
      validation_error: "The form has validation errors",
    },
  },
  Generic: {
    and: "and",
    and_x_more: "and {{count}} more",
  },
};
